import api from "./index";

export const GetPolygonModeId = async () => {
  const response = await api.get("/api/polygon-modes/available");
  return response.data;
};

export const PostGeometries = async (allPoints, data, polygonArea = null) => {
  const { workType, areaType, Name, newAreaName } = data;

  const coordinates = allPoints.map((point, index) => {
    return {
      x: point.longitude,
      y: point.latitude,
      z: 0,
      sequence: index,
    };
  });

  const postData = {
    name: Name,
    geometryType: workType === "pathGenerate" ? "PATH" : "POLYGON",
    coordinates: coordinates,
    polygonModeId: areaType,
    value:
      workType === "pathGenerate"
        ? allPoints[allPoints.length - 1].length
        : polygonArea,
  };

  
  try {
    const response = await api.post("/api/user-geometries", postData);
    return response.data;
  } catch (error) {
    console.error("지오메트리 저장 실패:", error);
    throw error;
  }
};

export const PostPolygonMode = async (requestData) => {
  const { newAreaName, areaColor } = requestData;
  const data = {
    modeName: newAreaName,
    modeColor: areaColor,
  };
  const response = await api.post("/api/polygon-modes/custom", data);
  return response.data;
};

export const DeletePolygonMode = async (id) => {
  
  const response = await api.delete(`/api/polygon-modes/custom/${id}`);
  
  return response.data;
};

export const getAreaList = async () => {
  const response = await api.get("/api/user-geometries");
  return response.data;
};

export const deleteArea = async (id) => {
  const response = await api.delete(`/api/user-geometries/${id}`);
  return response.data;
};

export const getAreaById = async (id) => {
  const response = await api.get(`/api/user-geometries/${id}`);
  return response.data;
};
